import { generateTitle } from '@application/ai-prompts/generate-title/command'

import AiGenerator from '@ui/shared/components/AiGenerator'

const faqs = [
  {
    question: 'How does the Title Generator come up with titles?',
    answer:
      'We trained the Title Generator model on a data set of title-abstract pairs. Through this training process, the model learned what elements from an abstract usually occur in the title, and how these are presented.',
  },
  {
    question: 'Can I also use the Title Generator for other genres?',
    answer:
      "Yes! Try entering a snippet from anything else, like a blog, movie review, or presentation script. You'll be surprised to see how spot-on the generated titles are, even when the text isn't academic.",
  },
  {
    question: 'Do you have an API of the Title Generator?',
    answer:
      'Yes, you can also use our API to automatically generate titles for texts. Contact us at enterprise@writefull.com for more information.',
  },
  {
    question: 'Is the Title Generator free to use?',
    answer:
      'Yes, you can also use our API to automatically generate titles for texts. Contact us at enterprise@writefull.com for more information.',
  },
  {
    question: 'What happens to the abstracts that I enter into the Title Generator? ',
    answer:
      "Nothing at all - we don't store anything. Your text is encrypted and sent to Writefull's servers where it is processed and removed straight after.",
  },
  {
    question: 'Why did you develop the Title Generator?',
    answer:
      "Most of the Writefull team members were researchers once. We know how difficult it can be to think of a good title for a paper, report, or other text. A title has to be catchy, informative, accurate, and concise - all at once. We used our love for AI and writing to introduce this helpful widget and make everyone's life easier.",
  },
]

const tableFeatures = [
  { feature: `🙌${'\u00A0'} Free to use`, description: 'No payment, completely free.' },
  {
    feature: `🔒${'\u00A0'} Safe & secure`,
    description: 'Your data is fully encrypted and never stored.',
  },
  {
    feature: `⚡${'\u00A0'} Fast title generation`,
    description: 'Get your title generated in just a few seconds.',
  },
  {
    feature: `👨‍💻${'\u00A0'} API access`,
    description: 'API access to the title generator on request.',
  },
]

export default function TitleGenerator() {
  const handleGenerateTitle = async (input: string) => {
    const title = await generateTitle(input)
    if (!title) {
      return undefined
    }
    return [title]
  }
  return (
    <AiGenerator
      label='Paste your abstract'
      actions={[
        {
          name: 'Generate Title',
          code: 'generate-title',
        },
      ]}
      skeleton={{ type: 'title', bars: 1 }}
      faqs={{ faqs, tableFeatures, widgetName: 'Title Generator' }}
      onGenerate={handleGenerateTitle}
    />
  )
}
